import { render } from "./PayrollHub.vue?vue&type=template&id=f7b99702&scoped=true"
import script from "./PayrollHub.vue?vue&type=script&lang=js"
export * from "./PayrollHub.vue?vue&type=script&lang=js"

import "./PayrollHub.vue?vue&type=style&index=0&id=f7b99702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b99702"]])

export default __exports__